import { useAuth } from "@/AuthContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useAuth();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggleTheme}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full border border-hairline hover:bg-pine-50 transition ${className}`}
      data-testid="theme-toggle-btn"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      {isDark ? <Sun className="w-4 h-4 text-pine" /> : <Moon className="w-4 h-4 text-pine" />}
    </button>
  );
}
